module.exports = __webpack_public_path__ + "static/img/us_embassy.8095a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/us_embassy.png
// module id = 102
// module chunks = 1